import { TbFlask } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const testingRoutes: NavigationRoute[] = [
    {
        meta: {
            label: "testing",
            order: 7,
            icon: TbFlask,
            visibleInSidebar: true,
            permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
        },
        to: APP_ROUTES_TO.TESTING,
    },
];
